export default "__VITE_ASSET__DSiNAjFp__"